import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const InquiryInfo = () => {
  const [select, setSelect] = useState(0);
  const [tab, setTab] = useState(1);
  const navigate = useNavigate();
  const location = useLocation();

  const handleTab = (num) => {
    setTab(num);
  };

  const moveBoard = (cate) => {
    navigate(`/board/${cate}`, { state: { cate } });
  };

  const movePage = (path) => {
    navigate(path);
  };

  const handleSelect = (num) => {
    if (select === num) {
      setSelect(0);
    } else {
      setSelect(num);
    }
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <div className="sub_wrap board">
      <div className="sub_back">
        {/* 상단 배너 */}
        <div className="sub_banner_area business-field">
          <div className="sub_banner_back">
            <div className="navi_text">
              <div className="home_icon_sub"></div>
              {'> '}기업연구동{' > '}입주안내
            </div>
            <div className="banner_main_text">입주안내</div>
          </div>
        </div>

        {/* 상단 네비게이션 */}
        <div className="navi_area">
          <div className="navi_back">
            <div className="navi_box" onClick={() => handleSelect(1)}>
              <div className="navi_main_text">기업연구동</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 1 && 'active'}`}>
                <div className="select_row" onClick={() => moveBoard('notice')}>
                  알림 및 소식
                </div>
                <div className="select_row" onClick={() => movePage('/fusionSupportProgram')}>
                  사업분야
                </div>
                <div className="select_row" onClick={() => movePage('/inquiryinfo')}>
                  기업연구동
                </div>
                <div className="select_row" onClick={() => movePage('/meetingroom')}>
                  보유시설
                </div>
                <div className="select_row" onClick={() => movePage('/vision')}>
                  융합원소개
                </div>
              </div>
            </div>

            <div className="navi_box" onClick={() => handleSelect(2)}>
              <div className="navi_main_text">입주안내</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 2 && 'active'}`}>
                <div className="select_row" onClick={() => movePage('/inquiryinfo')}>
                  입주안내
                </div>
                <div className="select_row" onClick={() => movePage('/floor')}>
                  층별안내
                </div>
                <div className="select_row" onClick={() => movePage('/company')}>
                  입주기업현황
                </div>
                <div className="select_row" onClick={() => moveBoard('inquiry')}>
                  입주문의
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 메인 */}
        <div className="sub_main_area board">
          {/* 고정 사이드바 */}
          <aside className="intro_aside_fixed">
            <div className="intro_aside_header">
              <div className="center_box">
                <span>기업연구동</span>
                <div className="center_line"></div>
              </div>
            </div>

            <ul className="intro_aside_list">
              <li className={`intro_aside_item ${isActive('/inquiryinfo')}`} onClick={() => movePage('/inquiryinfo')}>
                <span>입주안내</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/floor')}`} onClick={() => movePage('/floor')}>
                <span>층별안내</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/company')}`} onClick={() => movePage('/company')}>
                <span>입주기업 현황</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li
                className={`intro_aside_item ${isActive('/board/inquiry')}`}
                onClick={() => movePage('/board/inquiry')}
              >
                <span>입주문의</span>
                <span className="aside_arrow">&gt;</span>
              </li>
            </ul>
          </aside>

          <div className="board_container-sub">
            <div className="inquiry_area">
              {/* 타이틀 */}
              <div className="vision_title_box">
                <div className="logo_box">
                  <div className="logo_img"></div>
                </div>
                <div className="title_text">충남산학융합원 입주안내</div>
              </div>

              <div className="inquiry_top_box">
                <div className="top_title_box">
                  <div className="top_main_title">
                    기업연구동 <span>우수기업 입주 선정</span>
                  </div>
                  <div className="top_main_text">
                    충남산학융합지구 기업연구동이 중소벤처기업부로부터 신기술창업집적지역으로 지정(2017년 9월 1일)되어
                    다양한 기업의 지원시설로써 연구역량 강화 및 기술경쟁력을 확보하고, 공간과 인력·장비 등 보유시설
                    지원, 애로기술 해결 및 기술개발에 필요한 기업을 신청 받습니다.
                  </div>
                </div>

                {/* ✅ 섹션 1: 위치/공간 */}
                <div className="section_block">
                  <div className="section_head">
                    <div className="section_title">입주공간 안내</div>
                    <div className="section_desc">위치 및 운영층, 임대 타입을 확인하세요.</div>
                  </div>

                  {/* ✅ 주소 카드: 허전함 제거 핵심 */}
                  <div className="info_card">
                    <div className="info_card_icon" aria-hidden="true"></div>
                    <div className="info_card_body">
                      <div className="info_card_title">기업연구동 위치</div>
                      <div className="info_card_main">충남 당진시 석문면 산단7로 201 충남산학융합원 기업연구동</div>
                      <div className="info_card_meta">
                        <span className="meta_chip">운영층: 3층 ~ 5층</span>
                        <span className="meta_chip light">입주유형: A~D TYPE</span>
                      </div>
                      <div className="info_card_note">
                        입주 공간은 운영 여건에 따라 변동될 수 있으며, 상세 배정은 협의 후 확정됩니다.
                      </div>
                    </div>
                  </div>

                  <div className="inquiry_table_box">
                    <div className="inquiry_table">
                      <div className="table_caption">임대 타입별 면적</div>
                      <table>
                        <thead>
                          <tr>
                            <th>TYPE</th>
                            <th>평형</th>
                            <th>임대면적(㎡)</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>A</td>
                            <td>18평</td>
                            <td>60.41</td>
                          </tr>
                          <tr>
                            <td>B</td>
                            <td>26평</td>
                            <td>86.30</td>
                          </tr>
                          <tr>
                            <td>C</td>
                            <td>37평</td>
                            <td>120.82</td>
                          </tr>
                          <tr>
                            <td>D</td>
                            <td>46평</td>
                            <td>152.46</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                {/* ✅ 섹션 2: 임대료 */}
                <div className="section_block">
                  <div className="section_head">
                    <div className="section_title">임대료 기준 및 계약기간</div>
                    <div className="section_desc">부가세 별도 기준이며, 상세 조건은 계약 시 확정됩니다.</div>
                  </div>

                  <div className="inquiry_table_box bottom">
                    <div className="inquiry_table bottom">
                      <div className="table_caption">비용 및 계약 조건</div>
                      <table>
                        <thead>
                          <tr>
                            <th>구분</th>
                            <th>금액</th>
                            <th>비고</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>임대료</td>
                            <td>5,000원 / ㎡</td>
                            <td>-</td>
                          </tr>
                          <tr>
                            <td>시설관리비</td>
                            <td>5,000원 / 평</td>
                            <td>전기세 등 실비 별도</td>
                          </tr>
                          <tr>
                            <td>보증금</td>
                            <td>월 임대료 × 12개월</td>
                            <td>선납</td>
                          </tr>
                          <tr>
                            <td>계약기간</td>
                            <td>최초 2년</td>
                            <td>1년씩 연장 가능</td>
                          </tr>
                        </tbody>
                      </table>
                      <div className="table_footnote">
                        ※ 실제 부담 비용은 사용량(전기/공용비 등)에 따라 변동될 수 있습니다.
                      </div>
                    </div>
                  </div>
                </div>

                {/* ✅ 카드 2개 영역 (기존 구조 유지) */}
                <div className="top_info_row">
                  <div className="top_info_box left">
                    <div className="info_title">입주혜택</div>
                    <div className="info_text_box">
                      <div className="info_row">
                        <div className="info_title all_padding_none">정부지원 R&amp;D (사업계획서 작성지원)</div>
                      </div>
                      <div className="info_row">
                        <div className="info_title">공용장비 지원</div>
                        <div className="info_text">- 공용장비 사용료 할인 및 연구개발·시제품 제작 장비 지원 등</div>
                      </div>
                      <div className="info_row">
                        <div className="info_title">입주기업 무료 교육 프로그램 진행</div>
                        <div className="info_text">- 신산업 창출을 위한 R&amp;D 역량강화 교육 프로그램</div>
                        <div className="info_text">- 기업연구소(전담부서) 설치 및 신산업 전략 실습 프로그램</div>
                      </div>
                      <div className="info_row">
                        <div className="info_title bottom_padding_none">
                          재직자 교육을 통한 연구역량 강화 및 법률·특허·세무 등의 컨설팅
                        </div>
                      </div>
                      <div className="info_row">
                        <div className="info_title bottom_padding_none">
                          산학융합지구 내 공용시설 제공 (교육장, 세미나실, 회의실 등)
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="top_info_box right">
                    <div className="info_title">입주기업 선정</div>
                    <div className="info_text_box">
                      <div className="info_row">
                        <div className="info_title all_padding_none">
                          입주심사로 연구개발능력이 우수하고, 재무구조가 건전한 기업을 선정
                        </div>
                      </div>
                      <div className="info_row">
                        <div className="info_title">입주대상</div>
                        <div className="info_text">- 철강·소재산업, 자동차 부품 산업 등 기술연구소를 운영하는 기업</div>
                        <div className="info_text">- 신기술(3D 모델링, 시뮬레이션, FEM기법 등) 벤처기업</div>
                        <div className="info_text">- 신산업(4차 산업혁명 아이템) 등 신규 창업 기업</div>
                        <div className="info_text">- 기타 산학협력 활성화에 필요하다고 인정되는 기업</div>
                        <div className="info_text">- 기업지원을 위한 업종별 단체, 협회 지원기관 등</div>
                      </div>
                      <div className="info_row">
                        <div className="info_title">입주제한</div>
                        <div className="info_text">
                          - 충남산학융합지구 및 석문국가산업단지의 조성목적에 부합되지 아니하거나 공해·용수 그 밖의
                          사정으로 입주제한이 필요한 기업
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="inquiry_img_box bottom">
                  <div className="inquiry_img bottom"></div>
                </div>
              </div>

              {/* 상담 */}
              <div className="vision_title_box">
                <div className="logo_box">
                  <div className="logo_img"></div>
                </div>
                <div className="title_text">입주상담</div>
              </div>

              <div className="inquiry_bottom_box">
                <div className="bottom_row">
                  <span className="label">상담</span> 수시상담
                </div>
                <div className="bottom_row">
                  <span className="label">방문상담</span> 사단법인 충남산학융합원
                </div>
                <div className="bottom_row address">
                  <span className="label">주소</span>충남 당진시 석문면 산단7로 201 충남산학융합원 302호
                </div>
                <div className="bottom_row">
                  <span className="label">문의처</span> TEL . 041-354-8558
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* sub_main_area 끝 */}
      </div>
    </div>
  );
};

export default InquiryInfo;
